
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HeroSection from "@/components/why-spharaka/HeroSection";
import ProcessMonitoringSection from "@/components/why-spharaka/ProcessMonitoringSection";
import AgenticCapabilitiesSection from "@/components/why-spharaka/AgenticCapabilitiesSection";
import KeyFeaturesSection from "@/components/why-spharaka/KeyFeaturesSection";
import ComparisonSection from "@/components/why-spharaka/ComparisonSection";
import MetricsSection from "@/components/why-spharaka/MetricsSection";
import CallToActionSection from "@/components/why-spharaka/CallToActionSection";
import CanonicalTag from "@/components/seo/CanonicalTag";

const WhySpharaka = () => {
  useEffect(() => {
    // SEO Meta updates for Spharaka Networks
    document.title = "Why Choose Spharaka Networks - Advanced Cybersecurity Solutions";
    
    const metaDescription = document.querySelector('meta[name="description"]') || document.createElement('meta');
    metaDescription.setAttribute('name', 'description');
    metaDescription.setAttribute('content', 'Discover why organizations choose Spharaka Networks for advanced cybersecurity. Learn about our revolutionary approach to threat detection, investigation, and response.');
    if (!document.querySelector('meta[name="description"]')) {
      document.head.appendChild(metaDescription);
    }

    return () => {
      try {
        if (metaDescription.parentNode) {
          document.head.removeChild(metaDescription);
        }
      } catch (e) {}
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <CanonicalTag path="/why-spharaka" />
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <ProcessMonitoringSection />
        <AgenticCapabilitiesSection />
        <KeyFeaturesSection />
        <ComparisonSection />
        <MetricsSection />
        <CallToActionSection />
      </main>
      <Footer />
    </div>
  );
};

export default WhySpharaka;
